import init from 'elm/initializers'

addEventListener('DOMContentLoaded', (event) => {
  init()
})
